module.exports = __webpack_public_path__ + "img/raghi.76fe821c.png";